import { isEmpty, isEmail, isOnlyDigits, isAlphabetsWithSpace } from './validators'

export default function validateAuth(values) {
    let errors = {};
    Object.keys(values).map(key => {
        if(isEmpty(values.answer1) && isEmpty(values.answer2) && isEmpty(values.answer3)){
            errors.answer1 = "Please Write atleast one Feedback ";
            errors.answer2 = "Please Write atleast one Feedback ";
            errors.answer3 = "Please Write atleast one Feedback ";
        } else{
            return;
        }

    });
    console.log(errors)
    return errors;
}
